export default __webpack_public_path__ + "static/media/Octagon_Check.7ea1026e.svg";